<template>
    <flex-element
        v-plaintext
        :element-type="elementType"
        tag="a"
        :href="renderHref"
        :target="renderTarget"
        class="f-cursor-pointer"
        class-default="f-inline-block"
        :class="stateClasses"
        @click.native="onLinkClick"
    >
        <span
            v-text-select="singleLineTextNew"
            :contenteditable="isContentEditable"
            @input="setChangedData(true)"
            @blur="onInput"
        />
    </flex-element>
</template>

<script>
import { mapMutations } from 'vuex';
import { SET_SELECTED_LINK } from '@/store/types/mutation-types';
import baseAtom from '@/mixins/base-atom/base-atom-smart';
import { ALink } from '@/data/data-models';
import listenOnRootMixin from '@/mixins/listen-on-root';
import { STATE_CLASSES } from '@/data/constants/classes';

export default {
    name: 'a-link',
    mixins: [baseAtom, listenOnRootMixin],

    props: {
        displayName: {
            type: String,
            default: 'Link',
        },

        isLink: {
            type: Boolean,
            default: true,
        },

        singleLineText: {
            type: String,
            default: '',
        },

        templateId: {
            type: String,
            default: '{3608E54F-8A75-4FC6-AD2C-5B9392883DF5}',
        },

        // "isActive" is used here instead of "isSelected" because "isSelected" is already being used as a prop in base-element
        // ... even though setting this to true adds the is-selected class
        isActive: {
            type: Boolean,
            default: false,
        },

        isDisabled: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            cssDisplay: 'inline-block',
            isLinkNew: true, // Override to true to force link builder
            isMatchingLink: false,
            singleLineTextNew: '',
            STATE_CLASSES,
        };
    },

    computed: {
        stateClasses() {
            return {
                [STATE_CLASSES.MATCHING]: this.isMatchingLink,
                [STATE_CLASSES.SELECTED]: this.isActive,
            };
        },

        updatedElement() {
            return new ALink({
                ...this.updatedBaseElement,
                singleLineText: this.singleLineTextNew,
                isLink: true,
            });
        },
    },

    watch: {
        isMatchingLink(isMatching) {
            this.$emit('match', isMatching);
        },
    },

    mounted() {
        this.checkActive();
    },

    methods: {
        ...mapMutations({
            setSelectedLink: SET_SELECTED_LINK,
        }),

        checkActive() {
            if (this.href.includes('#')) {
                const currAnchor = window.location.hash.substring(1, window.location.hash.length);
                const splitHref = this.href.split('#');
                if (splitHref.length === 2 && currAnchor === splitHref[1]) {
                    this.isMatchingLink = true;
                }
            } else {
                // trim anchor and query
                const currentUrl = window.location.href.split('?')[0].split('#')[0];

                if (this.href.length && currentUrl.endsWith(this.href)) {
                    this.isMatchingLink = true;
                }
            }
        },

        setFieldValues() {
            this.singleLineTextNew = this.singleLineText
                || (this.$slots.default ? this.$slots.default[0].text.trim() : '[Text here]');
        },

        onInput(e) {
            this.singleLineTextNew = e.target.innerText;
        },

        onLinkClick(e) {
            if (this.isDisabled || !this.renderHref) e.preventDefault();
        },
    },
};
</script>
